/*
 * @version: V1.0.0
 * @Date: 2023-11-16 16:16:44
 * @LastEditors: lzq
 * @LastEditTime: 2023-11-16 16:37:48
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\utils\directive.js
 * @Descripttion:
 */
// maxlength.js文件
 /**
 * v-maxlength 限制el-select允许allow-create时输入的最大长度
 */
import Vue from "vue";

const maxlength = {
  inserted(el, binding) {
       let inputcontrol = el.querySelector('.el-input__inner')
       inputcontrol.setAttribute("maxlength", binding.value);
  }
}

Vue.directive('maxlength', maxlength)


